import { Link } from 'react-router-dom';

export default function SafetySection() {
  return (
    <section id="safety" className="py-16 md:py-24 px-4 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
          <div className="flex-1">
            <p className="text-xs md:text-sm text-foreground-500 font-medium uppercase tracking-wider mb-2">
              Important Information
            </p>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-6 leading-tight">
              Safety First
            </h2>
            <div className="space-y-4 text-foreground-700 text-sm md:text-base leading-relaxed">
              <p>
                This website does not sell products. All information is provided for educational and informational purposes only. We operate as an independent resource directory and are not affiliated with any specific sellers, vendors, or the AllChinaBuy platform.
              </p>
              <p>
                Users should <strong>independently verify</strong> sellers, prices, product information, and shipping details before making any purchase decisions. Always check seller ratings, read community reviews, and compare multiple sources before placing orders.
              </p>
              <p>
                Our directory is maintained with care, but the rapidly changing nature of the marketplace means information can become outdated. We encourage all users to exercise caution and conduct thorough research as part of their buying process.
              </p>
              <p>
                <strong>Updated: June 2026</strong> &mdash; Reviewed by our Editorial Team to ensure accuracy and completeness of all safety guidelines and resource listings.
              </p>
            </div>

            <div className="flex flex-wrap gap-3 mt-8">
              <Link
                to="/best-allchinabuy-spreadsheet/"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-secondary-100 text-secondary-800 rounded-full text-sm font-medium hover:bg-secondary-200 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shield-check-line"></i>
                Safety Guidelines
              </Link>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Browse Spreadsheets
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="bg-background-50 rounded-3xl p-6 md:p-8 border border-background-200/70">
              <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-5">
                Quick Safety Checklist
              </h3>
              <div className="space-y-4">
                {[
                  { icon: 'ri-user-search-line', text: 'Research seller history and ratings before purchasing' },
                  { icon: 'ri-image-line', text: 'Verify product photos are authentic and not stock images' },
                  { icon: 'ri-price-tag-3-line', text: 'Compare prices across multiple sellers and listings' },
                  { icon: 'ri-truck-line', text: 'Review shipping methods, costs, and estimated delivery times' },
                  { icon: 'ri-file-list-3-line', text: 'Read community reviews and feedback from other buyers' },
                  { icon: 'ri-shield-user-line', text: 'Use secure payment methods with buyer protection' },
                ].map((item, idx) => (
                  <div key={idx} className="flex items-start gap-3">
                    <span className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className={`${item.icon} text-primary-600 text-sm`}></i>
                    </span>
                    <p className="text-foreground-700 text-sm leading-relaxed">{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}